import { render, staticRenderFns } from "./RejectedTransaction.vue?vue&type=template&id=fa2d8b50"
import script from "./RejectedTransaction.vue?vue&type=script&lang=js"
export * from "./RejectedTransaction.vue?vue&type=script&lang=js"
import style0 from "./RejectedTransaction.vue?vue&type=style&index=0&id=fa2d8b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports